/* @flow */
import React from "react";
import * as styles from "./styles.module.css";
import { Icon, Theme, Type } from "@ebscois/react-component-library";

const ConsentDeleted = () => (
  <Theme>
    <div className={styles.ConsentDeleted}>
      <div className={styles.ConsentDeleted_content}>
        <span className={styles.ConsentDeleted_iconWrapper}>
          <div className={styles.ConsentDeleted_icon}>
            <Icon
              className={styles.ConsentDeleted_iconPosition}
              icon={{ glyph: "check", color: "green", size: "xl" }}
            />
          </div>
        </span>
        <Type element="h2" className={styles.ConsentDeleted_message}>
          Your request to delete your account was successful
        </Type>
        <Type element="h6">
          Your account and all your personal data will be permanently deleted
          soon. Please close any remaining browser windows related to this
          account.
        </Type>
      </div>
    </div>
  </Theme>
);

export default ConsentDeleted;
